module.exports = "<app-spinner #spinner>\n</app-spinner>\n"